/* eslint-disable no-extend-native */
// eslint-disable-next-line no-restricted-globals
String.prototype.lowerCaseFirstLetter = function lowerCaseFirstLetter(str: string): string {
  return str.charAt(0).toLowerCase() + str.slice(1);
};
